import { RecommendToEmployerBanner, CertificateBlock, CourseBanner } from "components"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

interface SidebarProps {
    courseBannerClassName?: string
    showRecommendBanner?: boolean
}

export function Sidebar({ showRecommendBanner = false, courseBannerClassName }: SidebarProps) {
    const [{ userAccount }] = useClientContext()
    const isB2b = userAccount?.is_b2b

    return (
        <div className="sidebar is-hidden-mobile">
            <CourseBanner className={courseBannerClassName} />
            <CertificateBlock />
            {showRecommendBanner && !isB2b ? <RecommendToEmployerBanner /> : ""}
        </div>
    )
}
